<template>
  <div class="w-full">
    <div class="my-2">
      <div :id="id"></div>
    </div>
    <div class="flex justify-between mb-1">
      <span :id="`${id}-min-value`"></span>
      <span><i class="fas fa-exchange-alt"></i></span>
      <span :id="`${id}-max-value`"></span>
    </div>
  </div>
</template>

<script>
import noUiSlider from "nouislider";
import { onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
export default {
  name: "nouislider",
  props: {
    id: {
      type: String,
      required: true
    },
    step: {
      type: Number,
      default: 1
    },
    range: {
      type: Object,
      required: true
    },
    start: {
      type: Array,
      required: true
    }
  },
  setup(props) {
    const route = useRoute();
    const router = useRouter();
    let movie_store = localStorage.getItem("movie_store");
    if (movie_store) {
      movie_store = JSON.parse(movie_store);
    }
    onMounted(() => {
      let slider = document.getElementById(props.id);
      let minValue = document.getElementById(`${props.id}-min-value`);
      let maxValue = document.getElementById(`${props.id}-max-value`);

      noUiSlider.create(slider, {
        start: props.start,
        connect: true,
        step: props.step,
        range: props.range
      });

      slider.noUiSlider.on("update", function(values) {
        let min = parseInt(values[0]);
        let max = parseInt(values[1]);

        minValue.innerHTML = min;
        maxValue.innerHTML = max;
      });

      slider.noUiSlider.on("set.one", function(values) {
        let min = parseInt(values[0]);
        let max = parseInt(values[1]);

        let newStore = {
          ...movie_store,
          runtime: [min, max]
        };
        localStorage.setItem("movie_store", JSON.stringify(newStore));

        router.push({
          path: route.path,
          query: {
            ...route.query,
            ...newStore
          }
        });
      });
    });
  }
};
</script>
